const KEY = "ecc_utm";

// First-touch attribution: capture ?utm_* / ?src= once per session so the
// params survive navigation between marketing pages before the lead submits.
export function captureUtm() {
  try {
    const p = new URLSearchParams(window.location.search);
    const source = p.get("utm_source") || p.get("src") || "";
    const medium = p.get("utm_medium") || "";
    const campaign = p.get("utm_campaign") || "";
    if ((source || medium || campaign) && !sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, JSON.stringify({ source, medium, campaign }));
    }
  } catch {
    /* storage unavailable */
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || { source: "", medium: "", campaign: "" };
  } catch {
    return { source: "", medium: "", campaign: "" };
  }
}
